export const getDashboardJson = (data) => {
  const datas = data && data.statistics ? data.statistics : {};
  return [
    {
      variant: "green",
      title: "Worker Balance",
      number: String(datas.employeeBalance),
      icon: "account_circle",
      trend: "trending_up",
      compare: "Workers",
      percent: datas.employeeCount,
    },
    {
      variant: "purple",
      title: "Vendor Balance",
      number: datas.partyBalacne,
      icon: "shopping_cart",
      trend: "trending_down",
      compare: "Parties",
      percent: datas.partyCount,
    },
    {
      variant: "blue",
      title: "Customer Balance",
      number: datas.customerBalance,
      icon: "shopping_bag",
      trend: "trending_down",
      compare: "Customers",
      percent: datas.customerCount,
    },
    {
      variant: "yellow",
      title: "Total Balance",
      number: datas.totalBalance,
      icon: "hotel_class",
      trend: "trending_up",
      compare: "Balance",
      percent: datas.customerCount + datas.partyCount,
    },
  ];
};
